export default __webpack_public_path__ + "static/media/task-image-02.7ddaead4.jpg";